/* CashNCarry Loot - keeps Loot shoppers inside Loot (Loot pages only; loaded by layout/theme.liquid).
   Server-side, the layout already points the header logo and the footer shop link at /pages/loot. This script covers
   what the theme re-renders in the browser:
   - cart drawer "Continue shopping" (and any link to /, /collections or /collections/all inside it) -> /pages/loot;
   - cart drawer recommendations and type/vendor/search links carry loot=1 (Loot products only);
   - the logo link again, in case the theme clones the header (sticky header).
   The store-switch bar (.cnc-switch) is never touched: its "CashNCarry" links are the intended way back. */
(function () {
  'use strict';
  if (!document.body.classList.contains('cnc-loot')) return;
  var root = ((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || '/').replace(/\/$/, '');
  var home = root + '/pages/loot';
  var logoLabel = document.body.getAttribute('data-loot-home-label') || 'CashNCarry Loot home';
  function addLoot(u) { if (!u || /[?&]loot=1/.test(u)) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'loot=1'; }
  var mainHome = [root + '/', root, '/'];
  var mainAll = [root + '/collections', root + '/collections/all', '/collections', '/collections/all'];

  /* Recommendation requests made from Loot pages ask for Loot products. */
  var prevFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string' && input.indexOf('/recommendations/products') > -1) input = addLoot(input);
    } catch (e) {}
    return prevFetch.apply(this, [input, init]);
  };

  function fix() {
    document.querySelectorAll('.header__logo--image, a.header__logo, .header__logo a').forEach(function (a) {
      if (a.closest('.cnc-switch')) return;
      if (a.getAttribute('href') !== home) a.setAttribute('href', home);
      if (a.getAttribute('aria-label') !== logoLabel) a.setAttribute('aria-label', logoLabel);
    });
    document.querySelectorAll('cart-drawer a[href]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (mainHome.indexOf(h) > -1 || mainAll.indexOf(h) > -1) a.setAttribute('href', home);
    });
    document.querySelectorAll('cart-drawer-products-recommendation[data-url]').forEach(function (el) {
      var u = el.getAttribute('data-url'), n = addLoot(u); if (n !== u) el.setAttribute('data-url', n);
    });
    /* v16: product-type / vendor links and main "all products" links lead to All Loot (the type and vendor pages
       are not Loot-only, and an unknown type 404s on a main-store page). */
    document.querySelectorAll('a[href*="/collections/types"], a[href*="/collections/vendors"], a[href="/collections/all"], a[href="/collections"]').forEach(function (a) {
      if (a.closest('.cnc-switch')) return;
      a.setAttribute('href', root + '/collections/loot-all');
    });
    document.querySelectorAll('a[href*="/search"]').forEach(function (a) {
      if (a.closest('.cnc-switch')) return;
      var h = a.getAttribute('href');
      if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/(search|collections\/types|collections\/vendors)(\?|$)/i.test(h)) {
        var n = addLoot(h); if (n !== h) a.setAttribute('href', n);
      }
    });
  }
  /* v16: delivery estimate in the Loot quick view. The card that opened it carries data-eta (from the product's
     custom.loot_delivery_estimate metafield); no estimate = the line stays hidden. Nothing is ever made up here. */
  var lastEta = '';
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-lc]');
    if (c) lastEta = c.getAttribute('data-eta') || '';
  }, true);
  var qv = document.querySelector('[data-lqv]'), etaEl = qv && qv.querySelector('[data-lqv-eta]');
  if (qv && etaEl && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (qv.hidden) return;
      etaEl.querySelector('span').textContent = lastEta;
      etaEl.hidden = !lastEta;
    }).observe(qv, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* v16: safety net for the theme's scroll lock. The theme removes body.modal-show / modal-showing when a drawer's
     overlay transition ends; if that event never arrives, the page would stay locked after the drawer closed.
     Only acts when no drawer or modal is open. */
  var lockTm;
  function unlockIfIdle() {
    clearTimeout(lockTm);
    lockTm = setTimeout(function () {
      var b = document.body;
      if (!b.classList.contains('modal-show') && !b.classList.contains('modal-showing')) return;
      if (document.querySelector('cart-drawer[open],menu-drawer[open],quick-view-modal[open],basic-modal[open],drawer-component[open],.drawer[open],.modal[open]')) return;
      b.classList.remove('modal-show', 'modal-showing');
    }, 1500);
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) { if (ms[i].attributeName === 'open' && !ms[i].target.hasAttribute('open')) { unlockIfIdle(); break; } }
    }).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
  }

  /* v16: header search with a Loot department chosen in the category select (options from window.CNC_DEPTS, set in
     snippets/cnc-loot-style): go straight to the Loot-only search for that department. The theme's own dept
     redirect (assets/search.js) would drop loot=1 and land on main-store results. */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.action || f.action.indexOf('/search') < 0) return;
    var sel = f.querySelector('.search__types select') || (f.closest('predictive-search,search-form') || f).querySelector('.search__types select');
    if (!sel || !sel.value || sel.value.indexOf('loot-') !== 0) return;
    var inp = f.querySelector('input[type="search"]') || f.querySelector('input[name="q"]');
    var q = inp ? inp.value.replace(' AND tag:Loot', '').trim() : ''; if (!q) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var p = new URLSearchParams(); p.set('q', q + ' AND tag:Loot'); p.set('type', 'product'); p.set('options[prefix]', 'last'); p.set('loot', '1'); p.set('dept', sel.value);
    location.href = root + '/search?' + p.toString();
  }, true);

  fix();
  if ('MutationObserver' in window) {
    var tm;
    new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(fix, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();